import React, { Suspense, useEffect, useMemo, useState } from 'react';
import Breadcrumb from '../../../../components/ui/materialui/breadcrumb';
import { Box, Paper, Typography } from '@mui/material';
import Tabla from '../../../../components/ui/materialui/tabla';
import { useForm } from 'react-hook-form';
import { IFilter } from '../../comun/components/cargarRespuestaComun';
import TableHeader from '../../../../components/ui/materialui/tableHeader';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import { AddTwoTone } from '@mui/icons-material';
import CargarRespuestaComun from '../../comun/components/cargarRespuestaComun';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { StatusCode } from '../../../../utils/enums';
import { useToast } from '../../../../hooks/useToast';
import { useColumnsError } from '../../comun/utils/columnsError';
import { useColumns } from '../utils/useColumns';
import useCargarCobrador from '../hooks/useCargaCobrador';
import { ArgumentosCargarArchivoCobro } from '../models/cargaCobro';
import { cargarArchivo } from '../services/servicesCargaCobro';
import { set } from 'date-fns';


const validationSchema = yup.object().shape({
    file: yup
        .mixed<File>()
        .nullable()
        .test('fileExists', 'El archivo es requerido', value => value === null || value instanceof File),
    tipoBeneficio: yup
        .string()
        .required('El tipo de beneficio es requerido'),
});

const CargaCobro: React.FC = () => {
    const { error, data, listar, limpiar, archivoTxt } = useCargarCobrador();
    const [disabledButton, setDisabledButton] = useState<boolean>(false);
    const { addToast } = useToast();
    const {
        formState: { errors },
        control,
        handleSubmit,
        watch,
        setValue
    } = useForm<IFilter>({
        resolver: yupResolver(validationSchema),
        // defaultValues: defaultValues,
        mode: 'onBlur'
    })

    const { COLUMNS } = useColumns();
    // eslint-disable-next-line
    const columns = useMemo(() => COLUMNS, [data]);

    const { COLUMNS: COLUMNSERROR } = useColumnsError();
    // eslint-disable-next-line
    const columnsError = useMemo(() => COLUMNSERROR, [error]);

    const { file } = watch();
    const breadcrumbItems = [
        { label: 'Inicio', url: '/' },
        { label: 'MINVU', url: `/minvu` },
        { label: 'Cargar respuesta cobro MINVU', active: true },
    ]

    const onSubmit = async (dataSubmit: IFilter) => {
        const requestData: ArgumentosCargarArchivoCobro = {
            listaArchivos: data ? data : [],
            nombreArchivo: dataSubmit.file ? dataSubmit.file.name : '',
            rutLogin: '11111111-1', // Aquí deberías obtener el RUT del usuario autenticado
            tipoBeneficio: dataSubmit.tipoBeneficio,
            txtArchivo: archivoTxt ?? ''
        };

        const respuesta = await cargarArchivo(requestData);
        if (respuesta.status === StatusCode.NoContent) {
            setDisabledButton(true);
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'Se ha cargado correctamente el archivo de cobro.',
            })
        }
    }

    useEffect(() => {
        if (file && file instanceof File) {
            listar(file);
            setDisabledButton(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [file]);

    return (
        <>
            <Suspense>
                <Breadcrumb items={breadcrumbItems} />
                <Box sx={{ mt: 2 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Suspense>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
                                    <Typography className='card-title' variant="h6" gutterBottom>
                                        Subir archivo
                                    </Typography>
                                    <CargarRespuestaComun
                                        control={control}
                                        errors={errors}
                                        watch={watch}
                                        setValue={setValue}
                                        limpiar={limpiar}
                                    />
                                </Paper>

                                {!error.length ? (
                                    <Tabla
                                        columns={columns}
                                        data={data}
                                        titulo={
                                            <TableHeader
                                                title=""
                                                button={
                                                    <MButton
                                                        type="submit"
                                                        variant="contained"
                                                        startIcon={<AddTwoTone />}
                                                        disabled={!data.length || !file || !archivoTxt || disabledButton}
                                                    // onClick={() => { onSubmit(watch()) }}
                                                    >
                                                        Confirmar carga
                                                    </MButton>
                                                }
                                            />
                                        }
                                    />
                                ) : (
                                    <Tabla
                                        columns={columnsError}
                                        data={error}
                                    />
                                )}
                            </form>
                        </Suspense>
                    </Paper>
                </Box>
            </Suspense>
        </>
    );
};

export default CargaCobro;